export default "__VITE_ASSET__1ee88576__"